import script from "./PopupWhatIsNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupWhatIsNew.vue?vue&type=script&setup=true&lang=ts"

import "./PopupWhatIsNew.vue?vue&type=style&index=0&id=30a116c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a116c3"]])

export default __exports__